/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Increase_QuantityInputs */

const en_increase_quantity = /** @type {(inputs: Increase_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase quantity`)
};

const th_increase_quantity = /** @type {(inputs: Increase_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มจำนวน`)
};

const ja_increase_quantity = /** @type {(inputs: Increase_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数量を増やす`)
};

const fr_increase_quantity = /** @type {(inputs: Increase_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Augmenter la quantité`)
};

const es_increase_quantity = /** @type {(inputs: Increase_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar cantidad`)
};

const ru_increase_quantity = /** @type {(inputs: Increase_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличить количество`)
};

const zh_increase_quantity = /** @type {(inputs: Increase_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`增加数量`)
};

const vi_increase_quantity = /** @type {(inputs: Increase_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tăng số lượng`)
};

/**
* | output |
* | --- |
* | "Increase quantity" |
*
* @param {Increase_QuantityInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const increase_quantity = /** @type {((inputs?: Increase_QuantityInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Increase_QuantityInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_increase_quantity(inputs)
	if (locale === "ja") return ja_increase_quantity(inputs)
	if (locale === "fr") return fr_increase_quantity(inputs)
	if (locale === "es") return es_increase_quantity(inputs)
	if (locale === "ru") return ru_increase_quantity(inputs)
	if (locale === "zh") return zh_increase_quantity(inputs)
	if (locale === "vi") return vi_increase_quantity(inputs)
	return en_increase_quantity(inputs)
});